import React, { useEffect } from 'react'
import {
  ListOrganization,
  ListProgram,
  ListEvent,
  ListResource,
  ListBlog
} from './components'
import { Container, DashboardSubNavs, UnderDevelopmentLabel } from '../../components'
import { Route } from 'react-router-dom'
import { useViewport } from '../../utils'
import { OrganizationsProvider } from '../../features/organizations'
import { SystemProvider } from '../../features/system/provider'
import { useDispatch, useSelector } from 'react-redux'
import { fetchIndividu } from '../../features/individu/slice'
import { useInternationalization } from '../../features/i18n'

const path = '/dashboard/bookmarks'

const Content = () => {
  return (
    <React.Fragment>
      <Route path={path+'/program'}>
        <ListProgram />
      </Route>
      <Route path={path+'/event'}>
        <ListEvent />
      </Route>
      <Route path={path+'/resource'}>
        <ListResource />
      </Route>
      <Route path={path+'/blog'}>
        <ListBlog />
      </Route>
      <Route path={path} exact>
        <OrganizationsProvider>
          <ListOrganization />
        </OrganizationsProvider>
      </Route>
    </React.Fragment>
  )
}

const DashboardBookmarks = () => {
  const dispatch = useDispatch()
  const { isDesktop } = useViewport()
  const { isIndividu } = useSelector(state => state.account)
  const id = useSelector(state => state.account.profile.id)
  const { translate } = useInternationalization()

  useEffect(() => {
    if(isIndividu && id){
      dispatch(fetchIndividu(id))
    }
  }, [dispatch, id, isIndividu])

  const subroutes = [
    {
      label: translate('ORGANIZATION', 'singular'),
      route: path,
      exact: true,
    },
    {
      label: translate('PROGRAM', 'singular'),
      route: path+'/program'
    },
    {
      label: translate('EVENT', 'singular'),
      route: path+'/event'
    },
    {
      label: translate('RESOURCE', 'singular'),
      route: path+'/resource'
    },
    {
      label: translate('BLOG', 'singular'),
      route: path+'/blog'
    }
  ]

  return isDesktop ? (
    <React.Fragment>
      <div className="hidden lg:block">
        <div className="mb-10">
          <h1 className="text-4xl font-bold font-primary">
            {translate('BOOKMARK', 'plural')}
          </h1>
          {
            !isIndividu &&
            <UnderDevelopmentLabel />
          }
        </div>
        <DashboardSubNavs links={subroutes}/>
      </div>
      <SystemProvider>
        <Content />
      </SystemProvider>
    </React.Fragment>
  ) : (
    <>
      <DashboardSubNavs links={subroutes}/>
      <Container>
        <Content />
      </Container>
    </>
  )
}

export { DashboardBookmarks }
